module.exports = __webpack_public_path__ + "static/media/attraction4.82091d75.jpg";